
export default class ProjectDocument {
  id: number;
  url: string;
  name: string;
  imageUrl: string;

  constructor(entity: ProjectDocument) {
    this.id = entity.id;
    this.url = entity.url;
    this.imageUrl = entity.imageUrl;
    this.name = entity.name;
  }
}



// WEBPACK FOOTER //
// ./src/entities/ProjectDocument.tsx